import axios from "axios";
import { API_URL } from "../config";
import authService from "./auth";

const isencaoLicenciamentoConsultaService = {
  criar: async (empreendimentoId, atividade, declaracao, oficio, documentacaoInteressado, comprovanteEndereco, declaracaoMeMei) => {
    const formData = new FormData();
    formData.append("EmpreendimentoId", empreendimentoId);
    formData.append("Atividade", atividade);
    formData.append("Declaracao", declaracao, "Declaracao.pdf");
    formData.append("Oficio", oficio, "Oficio.pdf");
    formData.append("DocumentacaoInteressado", documentacaoInteressado, "DocumentacaoInteressado.pdf");
    formData.append("ComprovanteEndereco", comprovanteEndereco, "ComprovanteEndereco.pdf");
    formData.append("DeclaracaoMeMei", declaracaoMeMei, "DeclaracaoMeMei.pdf");

    const response = await axios.post(`${API_URL}IsencaoLicenciamentoConsulta`, formData, {
      headers: {
        ...authService.getAuthHeader(),
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  },

  obterPorId: async (id) => {
    const response = await axios.get(`${API_URL}IsencaoLicenciamentoConsulta/${id}`, {
      headers: authService.getAuthHeader(),
    });
    return response.data.data;
  },

  listarMinhas: async (pageNumber = 1, pageSize = 5, empreendimentoId = null, dataInicio = null, dataFim = null, orderBy = "dataSolicitacao", orderDirection = "desc") => {
    const params = new URLSearchParams({ pageNumber, pageSize, orderBy, orderDirection });
    if (empreendimentoId) params.append("empreendimentoId", empreendimentoId);
    if (dataInicio) params.append("dataInicio", dataInicio);
    if (dataFim) params.append("dataFim", dataFim);

    const response = await axios.get(`${API_URL}IsencaoLicenciamentoConsulta/minhas?${params.toString()}`, {
      headers: authService.getAuthHeader(),
    });
    return response.data;
  },

  baixarDocumento: async (id, tipo) => {
    const response = await axios.get(
      `${API_URL}IsencaoLicenciamentoConsulta/${id}/documento/${tipo}`,
      { headers: authService.getAuthHeader() }
    );
    return response.data;
  },

  listarTodasAnalista: async ({
    pageNumber = 1,
    pageSize = 5,
    empreendimentoId = null,
    status = null,
    dataInicio = null,
    dataFim = null,
    orderBy = "dataSolicitacao",
    orderDirection = "desc",
  } = {}) => {
    const params = new URLSearchParams({ pageNumber, pageSize, orderBy, orderDirection });
    if (empreendimentoId) params.append("empreendimentoId", empreendimentoId);
    if (status !== null && status !== undefined) params.append("status", status);
    if (dataInicio) params.append("dataInicio", dataInicio);
    if (dataFim) params.append("dataFim", dataFim);

    const response = await axios.get(
      `${API_URL}IsencaoLicenciamentoConsulta/analista/todas?${params.toString()}`,
      { headers: authService.getAuthHeader() }
    );
    return response.data;
  },

  atualizarStatus: async (id, status, motivoIndeferimento = null) => {
    const body = { status };
    if (motivoIndeferimento !== null && motivoIndeferimento !== undefined) {
      body.motivoIndeferimento = motivoIndeferimento;
    }
    const response = await axios.put(
      `${API_URL}IsencaoLicenciamentoConsulta/${id}/status`,
      body,
      { headers: authService.getAuthHeader() }
    );
    return response.data;
  },

  emitir: async (id, pdfBlob, numeroInformado) => {
    const formData = new FormData();
    formData.append("Pdf", pdfBlob, "IsencaoEmitida.pdf");
    if (numeroInformado != null && String(numeroInformado).trim() !== "") {
      formData.append("numeroInformado", String(numeroInformado).trim());
    }
    const response = await axios.post(
      `${API_URL}IsencaoLicenciamentoConsulta/${id}/emitir`,
      formData,
      {
        headers: {
          ...authService.getAuthHeader(),
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  },

  assinarIsencao: async (id, certificadoPfxFile, certificadoSenha) => {
    const formData = new FormData();
    formData.append("certificadoPfx", certificadoPfxFile, certificadoPfxFile.name);
    formData.append("certificadoSenha", certificadoSenha);
    const response = await axios.post(
      `${API_URL}IsencaoLicenciamentoConsulta/${id}/assinar`,
      formData,
      {
        headers: {
          ...authService.getAuthHeader(),
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  },

  listarTodasSecretario: async ({
    pageNumber = 1,
    pageSize = 5,
    empreendimentoId = null,
    status = null,
    dataInicio = null,
    dataFim = null,
    orderBy = "dataSolicitacao",
    orderDirection = "desc",
  } = {}) => {
    const params = new URLSearchParams({ pageNumber, pageSize, orderBy, orderDirection });
    if (empreendimentoId) params.append("empreendimentoId", empreendimentoId);
    if (status !== null && status !== undefined) params.append("status", status);
    if (dataInicio) params.append("dataInicio", dataInicio);
    if (dataFim) params.append("dataFim", dataFim);

    const response = await axios.get(
      `${API_URL}IsencaoLicenciamentoConsulta/secretario/todas?${params.toString()}`,
      { headers: authService.getAuthHeader() }
    );
    return response.data;
  },

  baixarDocumentoEmitido: async (id) => {
    const response = await axios.get(
      `${API_URL}IsencaoLicenciamentoConsulta/${id}/documento/emitido`,
      { headers: authService.getAuthHeader() }
    );
    return response.data;
  },
};

export default isencaoLicenciamentoConsultaService;

